import { registerFragment } from '@neptune/cx/registry';
import './styles.scss';


registerFragment('chroa-heading', (fragmentElement, configuration, meta) => {

});

if (import.meta.hot) {
    import.meta.hot.accept();
}
